import type { WidgetPublicReview } from "@shared/contracts/widgets/public/common";
import { renderReviewCard } from "../components/reviewCard";
import type { Translator } from "../i18n/resolve";
import { escapeAttr } from "../utils/escape";

export type ListInput = {
  reviews: ReadonlyArray<WidgetPublicReview>;
  translate: Translator;
  now?: number;
};

export const renderList = ({ reviews, translate, now }: ListInput): string => {
  const items = reviews.map((review) => renderReviewCard({ review, translate, now })).join("");
  const label = escapeAttr(translate("wallLabel"));
  return `<section class="mbn-list" role="region" aria-label="${label}">${items}</section>`;
};
